import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { environment } from 'src/environments/environment';
import { CreditModel } from 'common/models/page-models/credits/credit-data-model';
import { CreditListingModel, CreditGridParams } from 'common/models/page-models/credits/credit-grid-model';



@Injectable({
    providedIn: 'root'
})
export class CreditGridDataService extends GridDataService<CreditListingModel, CreditModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getCreditMasterData, http, ss);
    }

    createInstance(): CreditListingModel {
        return new CreditListingModel();
    }

    override getDeleteUrl(): string {
        return environment.apiUrl + API_URL.deleteCreditMaster;
    }

    override getGridParams(param): GridPostParams {
        return new CreditGridParams();
    }
    override getDeletePayload(data) {
        let payload = {
            id: data.id
        }
        return payload;
    }
}
